module.exports = __webpack_public_path__ + "img/HC3P_Carrousel_4.40404959.jpg";